import { Button as AntButton } from "antd-mobile"
import styled, { css } from "styled-components"

export type IButtonType =
  | "primary"
  | "secondary"
  | "default"
  | "danger"
  | "cancel"
  | "info"
  | "transparent"

type ITheme = "light" | "dark"

export type IButtonSize = "small" | "large" | "middle"

const getButtonBg = (type: IButtonType, $theme?: ITheme) => {
  if (type === "primary") return "var(--color-primary)"

  if (type === "secondary")
    return $theme === "dark" ? "" : "var(--color-secondary)"

  if (type === "danger") return "var(--Schemes-On-Error-Container, #FF4921)"

  if (type === "cancel")
    return $theme === "dark"
      ? "#05050C"
      : "var(--Schemes-Surface-Container, #EBEDF0)"

  if (type === "info") return "var(--Schemes-Primary, #0DA3BA)"

  if (type === "transparent") {
    return "var(--white-white-10, rgba(255, 255, 255, 0.10))"
  }

  return "var(--color-white)"
}

const getButtonColor = (type: IButtonType, theme?: "light" | "dark") => {
  if (type === "danger") return "#fff"

  if (type === "info") return "#fff"

  if (type === "transparent") return "var(--Teal-Teal, #2CCCD3)"

  if (type === "cancel") return theme === "dark" ? "#fff" : "var(--color-navy)"

  return theme === "dark" ? "var(--color-app-navy)" : "var(--color-navy)"
}

const Button = styled(AntButton)<{
  $type: IButtonType
  $isOption?: boolean
  $size?: IButtonSize
  $isDeleteBtn?: boolean
  $borderLess?: boolean
  $theme?: "light" | "dark"
  $textColor?: string
}>`
  height: ${({ $isOption, $size }) =>
    $isOption ? "56px" : $size === "small" ? "36px" : "48px"};
  padding: ${({ $isOption, $size }) =>
    $isOption ? "15px 24px" : $size === "small" ? "6px 10px" : "12px 10px"};
  align-self: stretch;
  border-radius: ${({ $isOption, $isDeleteBtn }) =>
    $isOption || $isDeleteBtn ? "8px" : "100px"};
  background: ${({ $type, $theme }) => getButtonBg($type, $theme)};

  &::before {
    border-radius: ${({ $isOption, $isDeleteBtn }) =>
      $isOption || $isDeleteBtn ? "8px" : "100px"};
  }

  span {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;

    color: ${({ $type, $theme, $textColor }) =>
      $textColor ?? getButtonColor($type, $theme)};
    text-align: center;
    font-family: proxima-nova;
    font-size: ${({ $size }) => ($size === "small" ? "14px" : "16px")};
    font-weight: ${({ $size }) => ($size === "small" ? "600" : "700")};
    line-height: ${({ $isOption }) => ($isOption ? "160%" : "16px")};
    letter-spacing: 0.16px;
  }

  &.adm-button-disabled {
    background: ${(props) =>
      props.$theme === "dark"
        ? "var(--white-white-50, rgba(255, 255, 255, 0.50))"
        : "var(--Schemes-Outline-Variant, rgba(0, 38, 58, 0.14))"};

    opacity: 1;

    span {
      color: ${(props) =>
        props.$theme === "dark"
          ? "var(--App-Navy-Navy, #00263A)"
          : "var(--Schemes-On-Surface-Variant, #69757d)"};
    }
  }

  ${({ $borderLess }) =>
    $borderLess &&
    css`
      border: none !important;
    `}
`

export default Button
